<template>
  <div>
    <div>
      <b-modal
        ref="modal"
        centered
        body-bg-variant=""
        body-text-variant="dark"
        no-close-on-backdrop
        hide-footer
        hide-header
      >
        <div class="text-center pt-5">
          <p>
            <label class="pb-3">
              <h2>
                {{
                  $lang(
                    "儲存報名只為暫儲記錄，並未正式提交報名。請於報名截止前提交報名。"
                  )
                }}
              </h2>
            </label>
          </p>
          <p>
            <b-button @click="back()">{{ $lang("BTN_YES") }}</b-button>
          </p>
        </div>
      </b-modal>
    </div>
    <div class="form">
      <div v-show="!loading">
        <h1>{{ $lang("澳門婦女體育嘉年華") }}</h1>
        <b-form ref="form1" @submit="onSubmit">
          <div class="form-header">
            <div class="checkbox-group">
              <!-- <b-form-checkbox
                required
                v-model="form.isAgree"
                :disabled="is_perview"
              >
                <span style="padding-top: 2px" class="lbl">{{
                  $lang(
                    "由本人代表聲明參與的隊員已知悉活動當天需出示提前至少14天完成接種兩劑新型冠狀病毒疫苗或7日核酸檢測陰性的證明"
                  )
                }}</span>
              </b-form-checkbox> -->
              <b-form-checkbox
                required
                v-model="form.isAgree2"
                :disabled="is_perview"
              >
                <span class="lbl">
                  {{
                    $lang(
                      "由本人代表聲明參與的隊員的健康及體能良好，適宜參加上述活動"
                    )
                  }}</span
                >
              </b-form-checkbox>
            </div>
          </div>
          <b-form-group :label="$lang('團體名稱')">
            <b-form-input
              type="text"
              v-model="form.groupName"
              name="groupName"
              :class="errors.has('groupName') && 'is-invalid'"
              :placeholder="$lang('請輸入團體名稱')"
              :disabled="is_perview"
            />
            <b-form-invalid-feedback :state="errors.has('groupName')">
              {{ errors.first("groupName") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group :label="$lang('FIELD_CHILD_GROUP_NAME')">
            <b-form-input
              type="text"
              v-model="form.teamName"
              v-validate="'required'"
              name="teamName"
              :class="errors.has('teamName') && 'is-invalid'"
              :placeholder="$lang('請輸入隊伍名稱')"
              :disabled="is_perview"
            />
            <b-form-invalid-feedback :state="errors.has('teamName')">
              {{ errors.first("teamName") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group :label="$lang('參賽組別')">
            <b-form-radio-group
              id="radio-group-type1"
              v-model="form.groupType"
              name="groupType"
              :class="errors.has('groupType') && 'is-invalid'"
              :disabled="is_perview"
              required="required"
            >
              <b-form-radio value="A" v-validate="'required'">{{
                $lang("A組")
              }}</b-form-radio>
              <b-form-radio value="B" v-validate="'required'">{{
                $lang("B組")
              }}</b-form-radio>
            </b-form-radio-group>

            <b-form-invalid-feedback :state="errors.has('groupType')">
              {{ errors.first("groupType") }}
            </b-form-invalid-feedback>
          </b-form-group>

          <p>{{ $lang("隊伍名單") }}</p>
          <h4>{{ $lang("聯絡人") }}</h4>
          <div>
            <b-row>
              <b-col md="12">
                <b-form-group horizontal :label="$lang('姓名：')">
                  <b-form-input
                    type="text"
                    v-model="form.teamCaptain.name"
                    name="name"
                    :class="errors.has('name') && 'is-invalid'"
                    v-validate="'required'"
                    :placeholder="$lang('請輸入名字')"
                    :disabled="is_perview"
                  />
                  <b-form-invalid-feedback :state="errors.has('name')">
                    {{ errors.first("name") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group horizontal :label="$lang('電郵：')">
                  <b-form-input
                    type="text"
                    v-model="form.teamCaptain.email"
                    name="email"
                    :class="errors.has('email') && 'is-invalid'"
                    v-validate="'required|email'"
                    :placeholder="$lang('請輸入電郵')"
                    :disabled="is_perview"
                  />
                  <b-form-invalid-feedback :state="errors.has('email')">
                    {{ errors.first("email") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group horizontal :label="$lang('電話號碼：')">
                  <b-form-input
                    type="text"
                    v-model="form.teamCaptain.phone"
                    name="phone"
                    :class="errors.has('phone') && 'is-invalid'"
                    v-validate="'required|mobile'"
                    :placeholder="$lang('請輸入電話')"
                    :disabled="is_perview"
                  />
                  <b-form-invalid-feedback :state="errors.has('phone')">
                    {{ errors.first("phone") }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <!-- <b-col md="6">
                            <b-form-group horizontal :label-cols="3" :label="$lang('傳真：')">
                                <b-form-input type="text" v-model="form.teamCaptain.fax" name="fax" :class="errors.has('fax') && 'is-invalid'" :placeholder="$lang('請輸入傳真')" :disabled="is_perview" />
                                <b-form-invalid-feedback :state="errors.has('fax')">
                                    {{ errors.first("fax") }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col> -->
            </b-row>
          </div>

          <h4>{{ $lang("隊員") }}</h4>
          <template v-for="(item, index) in form.teamMembers">
            <women-form
              :requiredType="requiredType"
              :index="index + 1 + '.'"
              :key="item.key"
              :value="item"
              :rules="isACaptain ? rulesA : rulesB"
              class="dashed"
              ref="form-item"
              :disabled="is_perview"
            >
              <template v-if="form.teamMembers.length > 8" v-slot:remove>
                <b-form-group horizontal>
                  <!-- <label slot="label"></label> -->
                  <b-btn
                    variant="info"
                    size="sm"
                    class="del"
                    @click.prevent="handleRemove(item)"
                    ><i class="fa fa-trash-o" style="margin-right: 5px"></i
                    >{{ $lang("刪除") }}</b-btn
                  >
                </b-form-group>
              </template>
            </women-form>
          </template>

          <div class="form-footer">
            <div>
              <template v-if="!is_perview">
                <b-btn
                  v-if="form.teamMembers.length < 10"
                  variant="success btn-round"
                  @click.prevent="handleAdd"
                  >+{{ $lang("添加參賽者") }}</b-btn
                >
                <button
                  style="
                    background: linear-gradient(to right, #f36725, #f7b12b);
                  "
                  type="submit"
                  class="btn btn-primary btn-submit save"
                  @click="save"
                  :disabled="isDisable"
                >
                  {{ $lang("TEXT_SAVE") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-primary btn-submit save"
                  @click="submitForm"
                  :disabled="isDisable"
                >
                  {{ $lang("提交") }}
                </button>
              </template>
              <!-- <p>
                {{ $lang("TITLE_FORM_TIP") }}
              </p> -->
            </div>
          </div>
        </b-form>
      </div>
      <div class="spinner" v-show="loading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import WomenForm from "@/components/womenForm";
import InputFile from "@/components/InputFile";
import moment from "moment";
import { ValidationObserver } from "vee-validate";


export default {
  props: {
    mode: {
      type: String,
      default: "new",
    },
  },
  components: {
    InputFile,
    WomenForm,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      index: 4,
      requiredType: false,
      status: "",
      isDisable: false,
      // selected: "individual",
      isIdentity: true,
      // participateDate: [],
      rulesA: {
        birth: {
          women_carnival_a: [1983, 2005],
        },
        // idNumber: {
        //     idNumber: true
        // }
      },
      rulesB: {
        birth: {
          women_carnival_b: [1963, 1982],
        },
        // idNumber: {
        //     idNumber: true
        // }
      },
      form: {
        id: null,
        // healthFile: "",
        isAgree: false,
        isAgree2: null,
        groupName: "",
        teamName: "",
        groupType: "",
        teamCaptain: {
          name: "",
          phone: "",
          email: "",
          //   fax: ""
        },
        teamMembers: [
          // {
          //   name: "aasd",
          //   nameLang: "asd",
          //   phone: "61111111",
          //   idType: "3",
          //   idNumber: "55s55",
          //   bornAt: "1983-02-26",
          // },
          // {
          //   name: "asad",
          //   nameLang: "asd",
          //   phone: "61111111",
          //   idType: "3",
          //   idNumber: "s5555",
          //   bornAt: "1983-02-26",
          // },
          // {
          //   name: "asad",
          //   nameLang: "asd",
          //   phone: "61111111",
          //   idType: "3",
          //   idNumber: "555dd5",
          //   bornAt: "1983-02-26",
          // },
          // {
          //   name: "asd",
          //   nameLang: "asd",
          //   phone: "61111111",
          //   idType: "3",
          //   idNumber: "5555",
          //   bornAt: "1983-02-26",
          // },
          // {
          //   name: "asd",
          //   nameLang: "asd",
          //   phone: "61111111",
          //   idType: "3",
          //   idNumber: "55dd55",
          //   bornAt: "1983-02-26",
          // },
          // {
          //   name: "asd",
          //   nameLang: "asd",
          //   phone: "61111111",
          //   idType: "3",
          //   idNumber: "5dasd555",
          //   bornAt: "1983-02-26",
          // },
          // {
          //   name: "asd",
          //   nameLang: "asd",
          //   phone: "61111111",
          //   idType: "3",
          //   idNumber: "55dasds55",
          //   bornAt: "1983-02-26",
          // },
          // {
          //   name: "asd",
          //   nameLang: "asd",
          //   phone: "61111111",
          //   idType: "3",
          //   idNumber: "55dasdsa55",
          //   bornAt: "1983-02-26",
          // },
            {
              name: "",
              nameLang: "",
              phone: "",
              idType: 1,
              idNumber: "",
              bornAt: "",
            },
            {
              name: "",
              nameLang: "",
              phone: "",
              idType: 1,
              idNumber: "",
              bornAt: "",
            },
            {
              name: "",
              nameLang: "",
              phone: "",
              idType: 1,
              idNumber: "",
              bornAt: ""
            },
            {
              name: "",
              nameLang: "",
              phone: "",
              idType:1,
              idNumber: "",
              bornAt: ""
            },
            {
              name: "",
              nameLang: "",
              phone: "",
              idType:1,
              idNumber: "",
              bornAt:""
            },
            {
              name: "",
              nameLang: "",
              phone: "",
              idType: 1,
              idNumber: "",
              bornAt: ""
            },
            {
              name: "",
              nameLang: "",
              phone: "",
              idType:1,
              idNumber: "",
              bornAt: ""
            },
            {
              name: "",
              nameLang: "",
              phone: "",
              idType: 1,
              idNumber: "",
              bornAt: ""
            },
        ],
      },
    };
  },
  methods: {
    save() {
      this.requiredType = false;
      this.status = "draft";
    },
    submitForm() {
      this.requiredType = true;
      this.status = "approval";
    },
    back() {
      this.$router.push({
        name: "women-carnival",
      });
    },
    async onSubmit(evt) {
      evt.preventDefault();
      // this.form.teamCaptain.bornAt = this.$getYear(this.form.teamCaptain.bornAt) || "";
      var form = {
        ...this.form,
        status: this.status,
        teamMembers: this.uploadMembers(this.form.teamMembers),
      };
      if (this.status === "draft") {
        this.recordUpdate(form);
        this.errorScoll();
      } else {
        // var haveChild = this.haveChild(form);
        // if(haveChild) {
        //     var haveAdult = this.haveAdult(form);
        //     if(!haveAdult) {
        //         this.notification.warning(this.$lang("報名者不足15歲的需有至少一位成年人陪同"));
        //         return false;
        //     }
        // }
        this.$validator.validateAll();
        var promise_list = await this.$refs["form-item"].map((item) =>
          item.onSubmit()
        );
        // var result = promise_list.every(item => item);
        // await this.$validator.validateAll("form1");
        // this.errorScoll();
        // var needHealthFile = this.needHealthFile(form);
        this.$validator.validateAll("form1").then((validate) => {
          Promise.all(promise_list).then((list) => {
            var result = list.every((item) => item);
            this.errorScoll();

            if (
              !this.errors.has("phone") &&
              !this.errors.has("email") &&
              this.form.teamName !== "" &&
              this.form.groupType !== "" &&
              result
            ) {
              if (this.form.isAgree2) {
                this.recordUpdate(form);
              } else {
                   this.notification.warning(this.$lang("TEXT_WARNING_3"));
              }
            } else {
              this.errorScoll();
            }

            // if (!needHealthFile) {
            //     if (form.isAgree1) {
            //         if(result) {
            //             this.recordUpdate(form);
            //             this.errorScoll();
            //         }
            //     }else {
            //         this.notification.warning(this.$lang("TEXT_WARNING_3"));
            //     }
            // } else {
            //     if (form.isAgree1) {
            //         if (form.healthFile) {
            //             if(result) {
            //                 this.recordUpdate(form);
            //                 this.errorScoll();
            //             }
            //         }else {
            //             this.notification.warning(this.$lang("TEXT_WARNING_1"));
            //         }
            //     }else {
            //         this.notification.warning(this.$lang("TEXT_WARNING_3"));
            //     }
            // }
          });
        });
      }
    },
    // 防止連續點擊重複提交
    PreventDuplicateSubmit() {
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false; //点击一次时隔两秒后才能再次点击
      }, 2000);
    },
    errorScoll() {
      let errEle = document.querySelector(".is-invalid");
      errEle ? this.animateScroll(errEle, 50) : "";
    },
    animateScroll(element, speed) {
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + element.getBoundingClientRect().top;
      // 获取当前距离窗口的top值
      let osTop = document.documentElement.scrollTop || document.body.srcollTop;
      let requestId;
      let currentNumber = 0;
      //采用requestAnimationFrame，平滑动画
      function step() {
        if (osTop >= top) {
          currentNumber = osTop -= speed;
          window.scrollTo(0, osTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },
    // haveChild(form) {
    //     let haveChild = false;
    //     let teamMembers = form.teamMembers;
    //     teamMembers.forEach((item, index) => {
    //         const bornAt = item.bornAt;
    //         const year = utils.getYear(bornAt);
    //         if (year > 2006 && year <= 2009) {
    //             haveChild = true;
    //         }
    //     });
    //     return haveChild;
    // },
    // haveAdult(form) {
    //     let haveAdult = false;
    //     let teamMembers = form.teamMembers;
    //     teamMembers.forEach((item, index) => {
    //         const bornAt = item.bornAt;
    //         const year = utils.getYear(bornAt);
    //         if (year <= 2003 && year >= 1951) {
    //             haveAdult = true;
    //         }
    //     });
    //     return haveAdult;
    // },
    // needHealthFile(form) {
    //     let needHealthFile = false;
    //     let teamMembers = form.teamMembers;
    //     teamMembers.forEach((item, index) => {
    //         const bornAt = item.bornAt;
    //         const year = utils.getYear(bornAt);
    //         if (year > 2003 && year <= 2009) {
    //             needHealthFile = true;
    //         }
    //     });
    //     return needHealthFile;
    // },
    handleRemove(item) {
      if (this.form.teamMembers.length <= 1) {
        return;
      }
      var index = this.form.teamMembers.indexOf(item);
      if (index !== -1) {
        this.form.teamMembers.splice(index, 1);
      }
    },
    handleAdd() {
      this.index++;
      this.form.teamMembers.push({
        index: this.index,
        name: null,
        nameLang: null,
        phone: null,
        bornAt: '',
        idType:1,
        idNumber: ""
      });
    },
    uploadMembers(list) {
      return list.map((item, index) => {
        delete item["key"];
        delete item["index"];
        item.bornAt = this.$changeTime(item.bornAt) || null;;
        return item;
      });
    },
    recordUpdate(form) {
      if (this.status == "draft") {
        this.saveForm(form)
          .then((resp) => {
            // let type = this.mode;
            // if (type == "edit") {
            //     this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            // } else {
            // this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
            this.$refs["modal"].show();
            // }
            // this.$router.push({
            //     name: "women-carnival"
            // });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              if (err.data.length == 0) {
                this.notification.error(this.$lang(err.message));
              }
              var errs = err.data.teamMembers;
              var that = this;
              Object.keys(errs).forEach(function (key) {
                that.notification.error(that.$lang(errs[key].message));
              });
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      } else {
        this.recordPro(form)
          .then((resp) => {
            // let type = this.mode;
            // if (type == "edit") {
            //     this.notification.success(this.$lang("提交成功"));
            // } else {
            //     this.notification.success(this.$lang("提交成功"));
            // }
            this.notification.success(this.$lang("提交成功"));
            this.$router.push({
              name: "women-carnival",
            });
          })
          .catch((err) => {
            if (err.data.groupName) {
              this.errors.add({
                field: err.data.groupName.path,
                msg: err.data.groupName.message,
              });
              this.notification.error(this.$lang(err.data.groupName.message));
            }
            if (err.data.teamName) {
              this.errors.add({
                field: err.data.teamName.path,
                msg: err.data.teamName.message,
              });
              this.notification.error(this.$lang(err.data.teamName.message));
            }
            if (err.data.teamCaptain) {
              this.errors.add({
                field: err.data.teamCaptain.path,
                msg: err.data.teamCaptain.message,
              });
              this.notification.error(this.$lang(err.data.teamCaptain.message));
            }
            if (err.data.teamMembers) {
              if (err.data.teamMembers instanceof Array) {
                err.data.teamMembers.forEach((item, index) => {
                  this.$refs["form-item"][index].validateErrors(
                    item.path,
                    this.$lang(item.message)
                  );
                  this.notification.error(this.$lang(item.message));
                });
              } else {
                if (err.data.length == 0) {
                  this.notification.error(this.$lang(err.message));
                }
                var teamMembers = err.data.teamMembers;
                var that = this;
                Object.keys(teamMembers).forEach(function (key) {
                  that.$refs["form-item"][key].validateErrors(
                    teamMembers[key].path,
                    that.$lang(teamMembers[key].message)
                  );
                  that.notification.error(that.$lang(teamMembers[key].message));
                });
                // var errs = err.data.teamMembers;
                // var that = this;
                // Object.keys(errs).forEach(function (key) {
                //     that.notification.error(that.$lang(errs[key].message));
                // });
              }
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      }
    },
    async recordPro(form) {
      this.PreventDuplicateSubmit();
      return new Promise((resolve, reject) => {
        $apis.womenCarnival
          .recordUpdate(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // save
    async saveForm(form) {
      this.PreventDuplicateSubmit();
      return new Promise((resolve, reject) => {
        $apis.womenCarnival
          .save(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    async recordDetail(id) {
      if (this.mode === "perview") {
        this.loading = true;
        let resp = await $apis.womenCarnival.recordDetail({
          id,
        });
        this.loading = false;
        this.form = resp.data;
      } else {
        this.loading = true;
        let resp = await $apis.womenCarnival.load({ id });
        this.loading = false;
        this.form = resp.data;
      }
    },
    getUserInfo() {
      this.loading = true;
      $apis.user
        .getUserInfo()
        .then((resp) => {
          var data = resp.data;
          if (this.$route.params.locale == "zh-hant") {
            this.form.teamCaptain.name = data.firstNameZh + data.lastNameZh;
          } else {
            this.form.teamCaptain.name = data.firstNamePt + data.lastNamePt;
          }
          this.form.teamMembers[0].name = this.form.teamCaptain.name; //也默认
          // this.form.teamCaptain.bornAt = data.bornAt;
          // this.form.teamCaptain.idType = data.idType;
          // this.form.teamCaptain.idNumber = data.idNumber;
          this.form.teamCaptain.phone = data.contact[data.contact.length - 1];
          this.form.teamCaptain.email = data.email ? data.email : "";
          // this.form.teamCaptain.fax = '';
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    disabled() {
      return this.mode === "perview" || this.mode === "edit";
    },
    is_perview() {
      return this.mode === "perview";
    },
    is_edit() {
      return this.mode === "edit";
    },
    is_new() {
      return this.mode === "new";
    },
    downPdf() {
      return this.$store.getters["base/springFestivalCycleHealthFileExample"];
    },
    link() {
      return this.$store.getters["base/baseUrl"];
    },
    url() {
      return this.link + this.downPdf;
    },
    isACaptain() {
      // var value = this.form.teamCaptain.bornAt;
      // if (!value) return false;
      // var year = new Date(value).getFullYear();
      // let result = year >= 1981 && year <= 2003;
      // if (!result) {
      //     this.form.isAgree1 = null;
      // }
      return this.form.groupType === "A";
    },
    curYear() {
      return moment().format("YYYY");
    },
  },
  created() {
    var id = this.$route.params.slug;
    var isNew = this.is_new;
    this.form.id = id;
    id && this.recordDetail(id);
    isNew && this.getUserInfo();
  },
  // watch: {
  //     "form.teamCaptain.idType": {
  //         handler(n) {
  //             if (n == "1") {
  //                 this.isIdentity = true;
  //             } else {
  //                 this.isIdentity = false;
  //             }
  //         },
  //         immediate: true
  //     }
  // }
};
</script>
